import { render } from "./FileAClaim.vue?vue&type=template&id=450007da"
import script from "./FileAClaim.vue?vue&type=script&lang=js"
export * from "./FileAClaim.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__